import Dashboard from '@customer/templates/dashboard/Dashboard';
import HealthSummary from './components/health-summary/HealthSummary';
import SiteInsights from './components/site-insights/SiteInsights';
import PerformanceSummary from './components/performance-summary/PerformanceSummary';
import { useAppSelector } from '@customer/store/hooks';
import { Permission, userHasPermission } from '@customer/permissions';

export function Home() {
  const userData = useAppSelector(state => state.auth);
  const performanceReadAccess = userHasPermission(userData, Permission.PerformanceRead);
  return (
    <Dashboard>
      <SiteInsights />
      <HealthSummary />
      {performanceReadAccess && <PerformanceSummary />}
    </Dashboard>
  );
}

export default Home;
